<template>
  <page-wrapper :title="title">
    <div class="header" v-if="!$isCallCenter">
      <sc-button
        class="create-button"
        variant="primary"
        :route="providerCreateRoute"
        >เพิ่มผู้ให้บริการ</sc-button
      >
    </div>
    <div class="wrapper">
      <div class="row">
        <div class="col-3">
          <div class="label mb-2">ผู้ให้บริการ</div>
          <el-input v-model="providerName" />
        </div>
        <div class="col-2">
          <label class="label">ประเภทบุคคล</label>
          <el-select v-model="selectedProviderType" placeholder="ประเภทบุคคล">
            <el-option
              v-for="item in providerTypeDropdown"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="col-3">
          <div class="label">Tax ID</div>
          <el-input v-model="taxId" />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col text-right">
          <sc-button variant="primary" @click="handleClickSearch"
            >ค้นหา</sc-button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col text-right">
          <sc-button variant="secondary" @click="handleClickExportExcel">
            ดาวน์โหลดข้อมูลผู้ให้บริการ
          </sc-button>
        </div>
      </div>
    </div>
    <provider-list :data="providerList"></provider-list>
  </page-wrapper>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import ProviderList from "../components/ProviderList";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    PageWrapper,
    ProviderList,
    ScButton,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const title = "รายการผู้ให้บริการ";
    const providerCreateRoute = { name: "ProviderCreatePage" };
    const providers = [];
    const providerTypeDropdown = [
      { label: "ทั้งหมด", value: "" },
      { label: "บุคคลธรรมดา", value: "INDIVIDUAL" },
      { label: "นิติบุคคล", value: "CORPORATE" },
    ];
    const providerName = null;
    const taxId = null;

    return {
      title,
      providers,
      providerCreateRoute,
      providerTypeDropdown,
      providerName,
      selectedProviderType: null,
      taxId,
    };
  },
  watch: {
    "$route.query"() {
      this.setupProviderList();
    },
  },
  computed: {
    providerList() {
      return this.providers.map((provider) => {
        const id = provider.id;
        const name = provider.name;
        const iconUrl = provider.icon_url || "https//placehold.it/64";
        const route = { name: "ProviderDetailPage", params: { id } };
        const nameOnSap = provider.name_on_sap || "-";

        return {
          id,
          name,
          route,
          iconUrl,
          nameOnSap,
        };
      });
    },
    queryParams() {
      return {
        providerName: this.providerName || null,
        selectedProviderType: this.selectedProviderType || null,
        taxId: this.taxId || null,
      };
    },
  },
  created() {
    this.setupQuery();
    this.setupProviderList();
  },
  methods: {
    setupQuery() {
      this.providerName = this.$route.query.name;
      this.selectedProviderType = this.$route.query.providerType;
      this.taxId = this.$route.query.taxId;
    },
    async setupProviderList() {
      const providers = await this.fetchProviderList();

      this.providers = providers;
    },
    async fetchProviderList() {
      const response =
        await baanRueJaiClient.admin.subscriptions.providers.list(
          this.queryParams
        )

      return response.data.result;
    },
    async handleClickSearch() {
      const route = {
        name: this.$route.name,
        providerType: this.$route.providerType,
        query: {
          ...this.$route.query,
          name: this.providerName,
          providerType: this.selectedProviderType,
          taxId: this.taxId,
        },
      };
      this.$router.replace(route);
    },
     async handleClickExportExcel() {
      const response = await baanRueJaiClient.admin.subscriptions.providers.getReport( this.queryParams);
      const blob = new Blob([response.data]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `list-provider.xlsx`;
      link.click();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  padding: 30px;
  border-bottom: $border;
}

.label {
  margin-bottom: 8px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.wrapper {
  padding: ($space / 2) $space;
}

.larger-checkbox {
  transform: scale(1.25);
}

.indent-checkbox {
  &-title {
    margin-left: 4px;
  }
}

.input {
  margin-bottom: 20px;
}

.provider {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/providers/pages/ProviderListPage.vue